import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "layout-page" }
const _hoisted_2 = { class: "content-wrapper" }
const _hoisted_3 = { class: "" }
const _hoisted_4 = { class: "flex-grow-1 container-p-y px-4" }
const _hoisted_5 = { class: "d-flex justify-content-between aling-items-center" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h4", { class: "fw-bold py-3 mb-4" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-light" }, "Product"),
    /*#__PURE__*/_createTextVNode(" Settings ")
  ])
], -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Back to List")
const _hoisted_8 = { class: "" }
const _hoisted_9 = {
  key: 0,
  class: "alert alert-success alert-dismissible",
  role: "alert"
}
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Successfully ")
const _hoisted_11 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "aria-label": "Close"
}, null, -1)
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = {
  key: 1,
  class: "alert alert-danger alert-dismissible",
  role: "alert"
}
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Please Give The Valide Price Like (36.56) or (58.56) In The Buy & Sell Price ")
const _hoisted_15 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "aria-label": "Close"
}, null, -1)
const _hoisted_16 = [
  _hoisted_14,
  _hoisted_15
]
const _hoisted_17 = {
  key: 2,
  class: "d-flex justify-content-center align-items-center"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border text-primary",
  role: "status"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading...")
], -1)
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = { class: "row" }
const _hoisted_21 = { class: "col-md-12 col-sm-12" }
const _hoisted_22 = { class: "card" }
const _hoisted_23 = { class: "card-body" }
const _hoisted_24 = {
  key: 0,
  class: "d-flex justify-content-center align-items-center"
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border text-primary",
  role: "status"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading...")
], -1)
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = {
  key: 1,
  class: "card-body"
}
const _hoisted_28 = { class: "row mb-3" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("label", {
  class: "col-sm-12 col-form-label",
  for: "basic-icon-default-store"
}, "Select Category ", -1)
const _hoisted_30 = { class: "row mb-3" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("label", {
  class: "col-sm-12 col-form-label",
  for: "basic-icon-default-store"
}, "Name ", -1)
const _hoisted_32 = { class: "col-sm-12" }
const _hoisted_33 = { class: "row mb-3" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("label", {
  class: "col-sm-12 col-form-label",
  for: "basic-icon-default-store"
}, "Description ", -1)
const _hoisted_35 = { class: "col-sm-12" }
const _hoisted_36 = { class: "row mb-3" }
const _hoisted_37 = { class: "col-md-3 col-sm-12 mb-3" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("label", {
  class: "col-sm-12 col-form-label",
  for: "basic-icon-default-store"
}, "Buy Price ", -1)
const _hoisted_39 = { class: "col-sm-12" }
const _hoisted_40 = { class: "col-md-3 col-sm-12 mb-3" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("label", {
  class: "col-sm-12 col-form-label",
  for: "basic-icon-default-store"
}, "Sale Price ", -1)
const _hoisted_42 = { class: "col-sm-12" }
const _hoisted_43 = { class: "col-md-3 col-sm-12 mb-3" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("label", {
  class: "col-sm-12 col-form-label",
  for: "basic-icon-default-store"
}, "Unit ", -1)
const _hoisted_45 = { class: "col-sm-12" }
const _hoisted_46 = /*#__PURE__*/_createStaticVNode("<option value=\"\">-- Select Unit--</option><option value=\"PCS\">Pcs</option><option value=\"KG\">Kg</option><option value=\"ML\">Ml</option><option value=\"GM\">Gm</option><option value=\"POUND\">Pound </option><option value=\"PACKET\">Packet </option><option value=\"MILIMETER\">Mm</option>", 8)
const _hoisted_54 = [
  _hoisted_46
]
const _hoisted_55 = { class: "col-md-3 col-sm-12" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("label", {
  class: "col-sm-12 col-form-label",
  for: "basic-icon-default-store"
}, "Alert Quantity ", -1)
const _hoisted_57 = { class: "col-sm-12" }
const _hoisted_58 = { class: "col-md-12 col-sm-12" }
const _hoisted_59 = { class: "col-sm-12" }
const _hoisted_60 = ["disabled"]
const _hoisted_61 = { key: 0 }
const _hoisted_62 = {
  key: 1,
  class: "spinner-border spinner-border-sm",
  role: "status",
  "aria-hidden": "true"
}
const _hoisted_63 = {
  key: 2,
  class: "visually-show"
}
const _hoisted_64 = /*#__PURE__*/_createElementVNode("div", { class: "content-backdrop fade" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TopBarView = _resolveComponent("TopBarView")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_SeLect2 = _resolveComponent("SeLect2")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_TopBarView),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("div", null, [
                _createVNode(_component_router_link, {
                  to: "/product",
                  class: "btn btn-primary mt-2"
                }, {
                  default: _withCtx(() => [
                    _hoisted_7
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              (_ctx.successReport)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_12))
                : _createCommentVNode("", true),
              (_ctx.errorPrice)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_16))
                : _createCommentVNode("", true),
              (_ctx.loading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, _hoisted_19))
                : (_openBlock(), _createElementBlock("form", {
                    key: 3,
                    name: "",
                    onSubmit: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"]))
                  }, [
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("div", _hoisted_22, [
                          _createElementVNode("div", _hoisted_23, [
                            (_ctx.fetchCategoryList.length <= 1)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_24, _hoisted_26))
                              : (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                  _createElementVNode("div", _hoisted_28, [
                                    _hoisted_29,
                                    _createVNode(_component_SeLect2, {
                                      modelValue: _ctx.formData.category_id,
                                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.category_id) = $event)),
                                      required: "",
                                      placeholder: 'Select Category',
                                      options: _ctx.fetchCategoryList,
                                      class: "w-100 my-select",
                                      onChange: _ctx.myChangeEvent,
                                      onSelect: _ctx.mySelectEvent,
                                      multiple: false
                                    }, null, 8, ["modelValue", "options", "onChange", "onSelect"])
                                  ]),
                                  _createElementVNode("div", _hoisted_30, [
                                    _hoisted_31,
                                    _createElementVNode("div", _hoisted_32, [
                                      _withDirectives(_createElementVNode("input", {
                                        type: "text",
                                        class: "form-control",
                                        id: "basic-icon-default-fullname",
                                        placeholder: "Name",
                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.name) = $event)),
                                        required: ""
                                      }, null, 512), [
                                        [_vModelText, _ctx.formData.name]
                                      ])
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_33, [
                                    _hoisted_34,
                                    _createElementVNode("div", _hoisted_35, [
                                      _withDirectives(_createElementVNode("textarea", {
                                        class: "form-control",
                                        id: "exampleFormControlTextarea1",
                                        rows: "3",
                                        placeholder: "Description",
                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.description) = $event))
                                      }, null, 512), [
                                        [_vModelText, _ctx.formData.description]
                                      ])
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_36, [
                                    _createElementVNode("div", _hoisted_37, [
                                      _hoisted_38,
                                      _createElementVNode("div", _hoisted_39, [
                                        _withDirectives(_createElementVNode("input", {
                                          type: "text",
                                          class: "form-control",
                                          id: "basic-icon-default-fullname",
                                          placeholder: "Buy Price",
                                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.buy_price) = $event)),
                                          required: ""
                                        }, null, 512), [
                                          [_vModelText, _ctx.formData.buy_price]
                                        ])
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_40, [
                                      _hoisted_41,
                                      _createElementVNode("div", _hoisted_42, [
                                        _withDirectives(_createElementVNode("input", {
                                          type: "text",
                                          class: "form-control",
                                          id: "basic-icon-default-fullname",
                                          placeholder: "Sale Price",
                                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.sell_price) = $event)),
                                          required: ""
                                        }, null, 512), [
                                          [_vModelText, _ctx.formData.sell_price]
                                        ])
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_43, [
                                      _hoisted_44,
                                      _createElementVNode("div", _hoisted_45, [
                                        _withDirectives(_createElementVNode("select", {
                                          class: "form-select",
                                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.unit) = $event))
                                        }, _hoisted_54, 512), [
                                          [_vModelSelect, _ctx.formData.unit]
                                        ])
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_55, [
                                      _hoisted_56,
                                      _createElementVNode("div", _hoisted_57, [
                                        _withDirectives(_createElementVNode("input", {
                                          type: "text",
                                          class: "form-control",
                                          id: "basic-icon-default-fullname",
                                          placeholder: "Sale Price",
                                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.alert_quantity) = $event)),
                                          required: ""
                                        }, null, 512), [
                                          [_vModelText, _ctx.formData.alert_quantity]
                                        ])
                                      ])
                                    ])
                                  ])
                                ]))
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_58, [
                        _createElementVNode("div", _hoisted_59, [
                          _createElementVNode("button", {
                            type: "submit",
                            class: "btn btn-primary mt-3",
                            disabled: _ctx.submitBtn
                          }, [
                            (!_ctx.submitBtn)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_61, "Save"))
                              : _createCommentVNode("", true),
                            (_ctx.submitBtn)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_62))
                              : _createCommentVNode("", true),
                            (_ctx.submitBtn)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_63, " Saving ...."))
                              : _createCommentVNode("", true)
                          ], 8, _hoisted_60)
                        ])
                      ])
                    ])
                  ], 32))
            ])
          ])
        ])
      ]),
      _createVNode(_component_Footer),
      _hoisted_64
    ])
  ]))
}